export enum AssetType {
  LENDING = 1,
  INVOICE = 2,
  NOTE_TOKEN = 3,
}

// Invoice
export enum InvoiceStatus {
  DRAFT = 0,
  SUBMITTED = 1,
  ACCEPTED = 2,
  PAID = 3,
  FINANCED = 4,
  CANCELED = 5,
  PENDING_APPROVE = 6,
}

export enum AssetStatus {
  PAST_DUE = 'Past Due',
  ON_GOING = 'Ongoing',
  PAID = 'Paid',
  IN_PROGRESS = 'In progress', // Waiting for approval
  OVERDUE = 'Overdue',
}

export enum LoanStatus {
  PENDING = 0,
  SUCCESS = 1,
  WAITING_CONFIRM = 2,
  FAILED = -1,
  REPAID = 3,
}

export const documentConfig = {
  category: {
    LEGAL: 1,
    GENERAL: 2,
  },
  permission: {
    VIEW: 0,
    SIGNER: 1,
    EDIT: 2,
  },
  status: {
    INITIATED: 0,
    ANSWERED: 1,
    DOCUMENTED: 2,
    SIGNED: 3,
  },
  SIGNED: 1,
  PUBLISHED: 1,
};
